import EVENTS from '@shared/events';

import { BaseController } from '@shared/basecontroller.controller';

class PeertopeerController extends BaseController {
  constructor(AppService, PeerToPeerStore, TransactionApiService, PageService, $timeout) {
    'ngInject';

    super(AppService);

    this.PeerToPeerStore = PeerToPeerStore;
    this.TransactionApiService = TransactionApiService;
    this.PageService = PageService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.removeSettingsHighlight();
    this.checkStatus();

    this.addListener(EVENTS.BET_PROCESSED, event => this.refreshCustomerProducts());
    this.addListener(EVENTS.TRANSACTION_PROCESSED, event => this.refreshCustomerProducts());
  }

  refreshCustomerProducts() {
    this.broadcast('reload.customer-products');
  }

  onSuccessfulSubmission() {
    this.PageService.showModal('successModal');
  }

  finishTransaction() {
    this.PageService.goto('overview');
  }

  checkStatus() {
    this.TransactionApiService.condition()
    .then((response) => {
      if (!response.verified_at) {
        let checkBitcoin = response.details.enabledPaymentOption.filter(function(item) {
          return item.code === 'BITCOIN';
        });

        if ((response.currency.code !== 'BTC') || (checkBitcoin.length <= 0)) {
          $('#modal-p2p').show();
        }
      }
    });
  }

  removeSettingsHighlight() {
    this.$timeout(() => {
      $('#settings').removeClass('subdrop');
    }, 100);
  }
}

export default PeertopeerController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/peertopeer.controller.js